import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import React from 'react';

interface NoShowsStatsProps {
  show: number;
  noShow: number;
}

export const NoShowsStats: React.FC<NoShowsStatsProps> = ({ show, noShow }) => {
  return (
    <div className='grid grid-cols-2 gap-4 w-full'>
      <div className='bg-emerald-100/50 rounded-2xl p-5 text-center border border-emerald-100 group hover:bg-emerald-100 transition-colors'>
        <div className='flex items-center justify-center gap-2 mb-2'>
          <CheckCircleIcon className='!w-4 !h-4 text-emerald-600' />
          <span className='text-[10px] font-black text-emerald-700 uppercase tracking-widest'>
            Asistieron
          </span>
        </div>
        <p className='text-4xl font-black text-emerald-600 tabular-nums'>
          {show}
        </p>
      </div>

      <div className='bg-rose-100/50 rounded-2xl p-5 text-center border border-rose-100 group hover:bg-rose-100 transition-colors'>
        <div className='flex items-center justify-center gap-2 mb-2'>
          <PersonOffIcon className='!w-4 !h-4 text-rose-600' />
          <span className='text-[10px] font-black text-rose-700 uppercase tracking-widest'>
            No Vinieron
          </span>
        </div>
        <p className='text-4xl font-black text-rose-600 tabular-nums'>
          {noShow}
        </p>
      </div>
    </div>
  );
};
